import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import i18n from "@/i18n";

const PKG_ID = "second-opinion";
const CONTACT_TO = `/contact?type=beoordeling&pakket=${PKG_ID}`;

import { SecondOpinionPage } from "@/pages/second-opinion";

export const Route = createFileRoute("/second-opinion")({
  head: () => {
    const t = i18n.getFixedT("nl", "seo");
    return pageHead({
      lang: "nl",
      pathWithoutLang: "/second-opinion",
      title: t("second-opinion.title") as unknown as string,
      description: t("second-opinion.description") as unknown as string,
    });
  },
  component: SecondOpinionPage,
});
